<section class="products-hero">
    <div class="hero-content">
        <h1 class="hero-headline">Explore Our Complete Classroom Digitization Ecosystem</h1>
        <p class="hero-subtext">
            Smart Panels, IFP Protection (Shutter), All-in-One PCs, LMS, K-12 Content & Digital E-Library for modern
            learning.
        </p>
    </div>
</section>

<section class="products-section">
    <div class="container">
        <div class="products-grid">
            <div class="product-card" *ngFor="let product of products">
                <div class="product-image">
                    <img [src]="product.image" [alt]="product.name" loading="lazy">
                </div>
                <div class="product-content">
                    <h3 class="product-name">{{ product.name }}</h3>
                    <ul class="product-highlights">
                        <li *ngFor="let highlight of product.highlights">
                            <span class="checkmark">✔</span>
                            {{ highlight }}
                        </li>
                    </ul>
                    <a [routerLink]="product.link" class="btn-view-product">
                        View Product
                        <span class="arrow">→</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>